import { useState } from "react";
import { Alert, Box, Button, Stack, TextField, Typography } from "@mui/material";

import * as yup from "yup";

import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { confirmResetPassword } from "aws-amplify/auth";

import { RootState } from "@store/store";
import { PASSWORD } from "@helpers/regex";
import { setSignInStep } from "@store/slices/authSlice";

export const FormularioRecuperacionContrasenia = () => {
    const dispatch = useDispatch();

    const [error, setError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const accountRecover = useSelector((state: RootState) => state.app.session.recovery.username);

    const formik = useFormik({
        initialValues: {
            code: "",
            newPassword: "",
            email: "",
        },
        validationSchema: yup.object().shape({
            newPassword: yup
                .string()
                .matches(
                    PASSWORD,
                    "Formato incorrecto. Debe contener una letra mayúscula, número, carácter especial y más de 8 caracteres.",
                )
                .required("Campo requerido"),
            code: yup.string().required("Campo requerido"),
            email: yup.string().required("Campo requerido"),
        }),
        onSubmit: async (values) => {
            if (formik.isValid) {
                try {
                    setLoading(true);
                    setError(false);

                    await confirmResetPassword({
                        username: values.email,
                        confirmationCode: values.code,
                        newPassword: values.newPassword,
                    });

                    dispatch(setSignInStep("LOGIN"));
                } catch (error) {
                    setError(true);
                    console.log(error);
                    setLoading(false);
                }
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} noValidate>
            <Stack my={2} mx={4} direction={"column"} justifyContent={"flex-start"} alignItems={"center"}>
                <Typography variant="h2" fontWeight={700} color="#002652">
                    ¡Hola de nuevo!
                </Typography>
                <Typography my={3} textAlign={"center"} variant="body1" color="#002652">
                    Ingresa tu correo, la nueva contraseña y el código de verificación que se envió a tu correo.
                    {accountRecover.trim() == "" ? "" : ` de ${accountRecover}`}
                </Typography>
                {accountRecover.trim() == "" && (
                    <TextField
                        name="email"
                        sx={{ my: 2, width: "60%" }}
                        label="Correo"
                        type="email"
                        required
                        size="small"
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={(formik.touched.email && Boolean(formik.errors.email)) ?? false}
                        helperText={formik.touched.email && formik.errors.email}
                    />
                )}
                <TextField
                    name="newPassword"
                    sx={{ my: 2, width: "60%" }}
                    label="Nueva contraseña"
                    type="password"
                    required
                    size="small"
                    autoComplete="off"
                    slotProps={{
                        htmlInput: {
                            autoComplete: "new-password",
                        },
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={(formik.touched.newPassword && Boolean(formik.errors.newPassword)) ?? false}
                    helperText={formik.touched.newPassword && formik.errors.newPassword}
                />

                <TextField
                    name="code"
                    sx={{ my: 2, width: "60%" }}
                    label="Código de verificación"
                    type="password"
                    required
                    size="small"
                    autoComplete="off"
                    slotProps={{
                        htmlInput: {
                            autoComplete: "new-password",
                        },
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={(formik.touched.newPassword && Boolean(formik.errors.newPassword)) ?? false}
                    helperText={formik.touched.newPassword && formik.errors.newPassword}
                />
                {error && (
                    <Box sx={{ mt: 2 }}>
                        <Alert variant="outlined" severity="error">
                            Codigo incorrecto. Verifica el código de confirmación.
                        </Alert>
                    </Box>
                )}
                <Button type="submit" variant="contained" fullWidth sx={{ py: 1, mb: 5, mt: 3, maxWidth: "60%" }}>
                    Resetear contraseña
                </Button>
            </Stack>
        </form>
    );
};
